/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TechnicalVisitAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_STATUS = 'autocomplete-status',
  BREADCRUMB = 'breadcrumb',
  CHECKBOX_0 = 'checkbox-0',
  CHECKBOX_MOBILE = 'checkbox-mobile',
  CONTEXTUAL_BAR = 'contextual-bar',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  CONTEXTUAL_BAR_DESKTOP = 'contextual-bar-desktop',
  DATE_PICKER = 'date-picker',
  DATE_PICKER_MOBILE = 'date-picker-mobile',
  DECK_VISIT_LIST = 'deck-visit-list',
  DECK_VISIT_LIST_MOBILE = 'deck-visit-list-mobile',
  FETCH_0 = 'fetch-0',
  FETCH_STATUS = 'fetch-status',
  FETCH_VISIT_LIST_DESKTOP = 'fetch-visit-list-desktop',
  FETCH_VISIT_LIST_MOBILE = 'fetch-visit-list-mobile',
  FIELD_0 = 'field-0',
  FIELD_CHECKBOX = 'field-checkbox',
  FIELD_CHECKBOX_MOBILE = 'field-checkbox-mobile',
  FIELD_DATE = 'field-date',
  FIELD_DATE_MOBILE = 'field-date-mobile',
  FIELD_DATEPICKER = 'field-datepicker',
  FIELD_DATEPICKER_MOBILE = 'field-datepicker-mobile',
  FIELD_RESPONSIBLE = 'field-responsible',
  FIELD_RESPONSIBLE_MOBILE = 'field-responsible-mobile',
  FIELD_STATUS = 'field-status',
  FIELD_TYPE = 'field-type',
  FIELD_TYPE_MOBILE = 'field-type-mobile',
  FILTER_TECHNICAL_VISIT = 'filter-technical-visit',
  FILTERED_LIST = 'filtered-list',
  FORM_DATE_PICKER = 'form-date-picker',
  FORM_DATE_PICKER_MOBILE = 'form-date-picker-mobile',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_CUSTOM_CARD_MOBILE = 'hpms-custom-card-mobile',
  HPMS_DYNAMIC_CONTENT_FIELD = 'hpms-dynamic-content-field',
  HPMS_DYNAMIC_CONTENT_FIELD_MOBILE = 'hpms-dynamic-content-field-mobile',
  LAYOUT_BODY = 'layout-body',
  LAYOUT_MOBILE = 'layout-mobile',
  LAYOUT_TECHNICAL_VISIT = 'layout-technical-visit',
  LAYOUT_TECHNICAL_VISIT_DESKTOP = 'layout-technical-visit-desktop',
  MAPPER_0 = 'mapper-0',
  MAPPER_STATUS = 'mapper-status',
  PANEL_BAR = 'panel-bar',
  PANEL_BREADCRUMB = 'panel-breadcrumb',
  PANEL_DATE_PICKER = 'panel-date-picker',
  PANEL_DATE_PICKER_MOBILE = 'panel-date-picker-mobile',
  PANEL_DESKTOP = 'panel-desktop',
  PANEL_FILTER = 'panel-filter',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_VISIT_LIST = 'panel-visit-list',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_5 = 'text-5',
  TEXT_DATE_MOBILE = 'text-date-mobile',
  TEXT_RESPONSIBLE_MOBILE = 'text-responsible-mobile',
  TEXT_STATUS = 'text-status',
  TEXT_TYPE_MOBILE = 'text-type--mobile',
}
export { TechnicalVisitAliases };
